const DEFAULT_FILE_REDUX_STATE = {
  processingFiles: [],
  uploading: [],
  analyzing: [],
};

export default DEFAULT_FILE_REDUX_STATE;
